var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelIcon = function SvgCancelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.262 14.324a.3.3 0 0 0 0 .424l.99.99a.3.3 0 0 0 .425 0L11 12.414l3.323 3.324a.3.3 0 0 0 .425 0l.99-.99a.3.3 0 0 0 0-.425L12.414 11l3.324-3.323a.3.3 0 0 0 0-.425l-.99-.99a.3.3 0 0 0-.425 0L11 9.586 7.677 6.262a.3.3 0 0 0-.425 0l-.99.99a.3.3 0 0 0 0 .425L9.586 11z"
  })));
};
export default SvgCancelIcon;